<template>
  <div class="page-footer" align="center">
    <div class="page-footer-inner">
      <!--<div class="footer-links">
        <a href="http://www.awesome.dev/businessforgood/about-us/" target="_blank">About us</a> | <a
              href="http://www.awesome.dev/businessforgood/blog/" target="_blank">Stories</a> | <a
              href="http://www.awesome.dev/businessforgood/faq/" target="_blank">FAQ</a> | <a
              href="http://www.awesome.dev/businessforgood/faq/" target="_blank">Contact us</a>|<a
              href="http://www.awesome.dev/businessforgood/terms/" target="_blank">Terms & Conditions</a>
      </div>-->
      <div>Copyright &copy; 2007 - {{getCurrentYear()}} Buy1Give1 Pte Ltd/B1G1 Giving Inc</div>
    </div>
    <div class="social-icon-footer">
      <a href="https://www.facebook.com/b1g1giving" target="_blank" class="fa fa-facebook fa-2x"></a>
      <a href="https://twitter.com/B1G1" target="_blank" class="fa fa-x-twitter fa-2x"></a>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    getCurrentYear () {
      return new Date().getFullYear()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/partner/Footer.vue